import React from 'react';
import { Layers, Share2, Globe, ArrowRight } from 'lucide-react';

const ServicesSection: React.FC = () => {
  const services = [
    {
      icon: <Layers className="w-8 h-8 text-[#C5A059]" />,
      pillar: "Pillar 01",
      title: "Investment Catalyst",
      desc: "We translate complex geological data into high-trust commercial narratives that satisfy the rigor of institutional investment committees."
    },
    {
      icon: <Share2 className="w-8 h-8 text-[#C5A059]" />,
      pillar: "Pillar 02",
      title: "Ethical Supply Connector",
      desc: "Positioning your operation for global OEMs and buyers who demand verified ESG compliance and transparent traceability."
    },
    {
      icon: <Globe className="w-8 h-8 text-[#C5A059]" />,
      pillar: "Pillar 03",
      title: "Global Procurement Door",
      desc: "Custom digital systems and strategic visibility frameworks that place your mine in front of international decision-makers."
    }
  ];

  return (
    <section id="services" className="py-24 bg-[#010712] flex justify-center px-4 scroll-mt-32">
      <div className="w-full max-w-[1440px] bg-[#0a1220]/30 backdrop-blur-xl text-white rounded-none py-24 px-6 md:px-16 relative overflow-hidden shadow-[0_20px_50px_rgba(0,0,0,0.5)]">
        {/* Decorative Background Glow */}
        <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-[#C5A059]/5 blur-[120px] rounded-full -translate-y-1/2 translate-x-1/3 pointer-events-none" />
        
        <div className="max-w-3xl mb-20 relative z-10">
          <span className="text-[#C5A059] text-[10px] md:text-[11px] font-bold uppercase tracking-[0.3em] mb-6 block">
            Capability Pillars
          </span>
          <h2 className="text-3xl md:text-5xl font-bold tracking-tight leading-tight">
            Three Ways We Make Mines Investable and Visible.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12 relative z-10">
          {services.map((service, idx) => (
            <div 
              key={idx} 
              className="flex flex-col group p-8 bg-[#111d30]/30 backdrop-blur-md rounded-none hover:bg-[#111d30]/60 transition-all duration-500"
            >
              <div className="flex justify-between items-start mb-6">
                <div className="w-14 h-14 flex items-center justify-center bg-[#111d30] rounded-none group-hover:scale-110 group-hover:bg-[#1b2b42] transition-all duration-500">
                  {service.icon}
                </div>
                {/* Level 1 Metadata */}
                <span className="text-zinc-500 text-[11px] font-bold uppercase tracking-widest mt-1">
                  {service.pillar}
                </span>
              </div>
              
              <h3 className="text-xl md:text-2xl font-bold mb-5 tracking-tight uppercase group-hover:text-[#C5A059] transition-colors leading-tight">
                {service.title}
              </h3>
              
              <p className="text-zinc-400 text-[14px] md:text-[15px] leading-relaxed mb-10 flex-grow">
                {service.desc}
              </p>
              
              {/* Level 2 Functional Label */}
              <a 
                href="https://wa.me/27839287731"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 text-[13px] font-bold uppercase tracking-widest text-[#C5A059] border-t border-white/5 pt-6 w-full hover:text-white transition-all bg-transparent whitespace-nowrap"
              >
                Enquire Now
                <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
